module.exports = __webpack_public_path__ + "static/img/thum-ecom.00a1b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/thum-ecom.png
// module id = jweU
// module chunks = 150